var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"menu_links"},_vm._l((_vm.links),function(link,index){return _c('div',{key:index,staticClass:"div_links"},[_c('a',{staticClass:"socialmedia",style:(_vm.dynamicStyle),attrs:{"href":link.url,"target":"_blank","rel":"noopener noreferrer"}},[_c('i',{class:link.icon})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }